<header class="i4u-header">
  <div class="i4u-header__content">
    @if (showBackButton) {
      <a [routerLink]="backLink" class="i4u-back-btn" [attr.aria-label]="'COMMON.GO_BACK' | translate">
        <i class="fa-solid fa-arrow-left"></i>
      </a>
    }
    <h1 class="i4u-header__title">{{ title }}</h1>
  </div>

  <div class="i4u-header__actions">
    <app-choose-language></app-choose-language>

    <app-notification></app-notification>

    <ng-content select="[slot='right-actions']"></ng-content>

    @if (showLogout) {
      <!-- <button 
        class="i4u-header__logout-btn" 
        (click)="logout()"
        [attr.aria-label]="'COMMON.LOGOUT' | translate">
        <i class="fa-solid fa-power-off"></i>
        <span class="i4u-hide-mobile">{{ 'COMMON.LOGOUT' | translate }}</span>
      </button> -->
      <button 
        class="home-header__logout" 
        (click)="logout()"
        aria-label="{{ 'COMMON.LOGOUT' | translate }}">
        <i class="fa-solid fa-power-off" aria-hidden="true"></i>
        <span>{{ 'COMMON.LOGOUT' | translate }}</span>
      </button>
    }
  </div>
</header>